{
  "version": 1,
  "asset_id": "2a23b36b-bdef-403d-b112-b95c1e3481ff",
  "project_id": "7ac59465-c0f2-4b6e-9949-d18c7a8fae04",
  "url": "/__l5e/assets-v1/2a23b36b-bdef-403d-b112-b95c1e3481ff/cover-400.jpg",
  "r2_key": "a/v1/7ac59465-c0f2-4b6e-9949-d18c7a8fae04/2a23b36b-bdef-403d-b112-b95c1e3481ff/cover-400.jpg",
  "original_filename": "cover-400.jpg",
  "size": 22484,
  "content_type": "image/jpeg",
  "created_at": "2026-06-25T01:16:05Z"
}
